@if(required) {
<div
  class="weaveFormField weaveDatePicker"
  [ngClass]="{'withClear': allowClear}"
  >
  @if (label && longTitle) {
    <div class="pageHeader">{{label}}<span class="required">*</span></div>
  }
  <div class="innerWeaveDatePicker">
    <mat-form-field appearance="outline">
      @if (label && !longTitle) { <mat-label>{{label}}</mat-label> }
      <input
        matInput
        [(ngModel)]="dataDate"
        (dateChange)="onFocusOut($event)"
        [matDatepicker]="picker"
        required
        #ctrl="ngModel"
        (click)="onFocusIn(); picker.open()"
        (focusin)="onFocusIn(); picker.open()"
        [disabled]="disabledFlag"
      >
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker (closed)="onDatePickerPopupClose()"></mat-datepicker>
      @if(ctrl.invalid && ctrl.touched) {
        <mat-error>
          {{label || "This field"}} is required
        </mat-error>
      }
    </mat-form-field>
    @if (allowClear && data && !disabledFlag) {
      <button (click)="clearDate()" class="clearDate">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
      </button>
    }
  </div>
</div>
}
@if(!required) {
  <div
  class="weaveFormField weaveDatePicker"
  [ngClass]="{'withClear': allowClear}"
  >
  @if (label && longTitle) {
    <div class="pageHeader" >{{label}}</div>
  }
  <div class="innerWeaveDatePicker">
    <mat-form-field appearance="outline">
      @if (label && !longTitle) { <mat-label>{{label}}</mat-label> }
      <input
        matInput
        [(ngModel)]="dataDate"
        (dateChange)="onFocusOut($event)"
        [matDatepicker]="picker"
        (click)="onFocusIn(); picker.open()"
        (focusin)="onFocusIn(); picker.open()"
        [disabled]="disabledFlag"
      >
      <mat-datepicker-toggle matIconSuffix [for]="picker" style="margin-left: -40px;"></mat-datepicker-toggle>
      <mat-datepicker #picker (closed)="onDatePickerPopupClose()"></mat-datepicker>
    </mat-form-field>
    @if (allowClear && data && !disabledFlag) {
      <button (click)="clearDate()" class="clearDate">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
      </button>
    }
  </div>
</div>
}
